import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {PesquisaComponent} from './pages/pesquisa/pesquisa.component';

//app/66482084
//ng build --base-href /Transparencia/ --output-path=./Transparencia
const routes: Routes = [

  {path: '/Transparencia/app/:raiz', redirectTo: 'app/:raiz', pathMatch: 'full'},
  { path: 'app/:raiz', component: PesquisaComponent },
  { path: '**', component: PesquisaComponent }

];

@NgModule({
  declarations: [],
  exports: [RouterModule],
  imports: [
    CommonModule,
    [RouterModule.forRoot(routes)]
  ]
})
export class AppRoutingModule {

}
